/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

import {
    Configuration,
    ConfigurationParameters,
    LastViewedPosition,
    SetSoCuLastViewedPositionRequest,
    SoCuLastViewedPositionApi,
} from 'client-code/last-viewed-position';
import { IVodSocuLastViewedPositionServiceRepository } from '../interfaces/IVodSocuLastViewedPositionServiceRepository';
import { Log } from '../logging/Log';
import { TServicesParams, TSocuLastViewedPositionParams } from '../types';
import { Constants } from '../constants';
import { CommonHeaders } from '../CommonHeaders';

export class VodSocuLastViewedPositionRepositoryImpl
    implements IVodSocuLastViewedPositionServiceRepository
{
    mParams: TServicesParams;

    TAG: string = 'VodSocuLastViewedPositionRepositoryImpl';

    constructor(params: TServicesParams) {
        this.mParams = params;
    }

    private async setSocuLastViewedPositionAtService(
        socuLVPParams: TSocuLastViewedPositionParams,
    ): Promise<void> {
        try {
            const commonHeaders = new CommonHeaders(socuLVPParams.screenType).headers;
            const configurationParameters: ConfigurationParameters = {
                apiKey: this.mParams.accessToken,
                basePath: this.mParams.basePath,
                baseOptions: {
                    timeout: Constants.SERVICE_CONNECTION_TIMEOUT,
                    headers: commonHeaders,
                },
            };

            const lastViewedPositionRequest: LastViewedPosition = {
                lastViewedPosition: socuLVPParams.lastViewedPosition,
                partnerOfferId: socuLVPParams.partnerOfferId,
                providerPartnerId: socuLVPParams.providerPartnerId,
                contentId: socuLVPParams.contentId,
                collectionId: socuLVPParams.collectionId,
                duration: socuLVPParams.duration,
            };

            const requestParameters: SetSoCuLastViewedPositionRequest = {
                applicationFeatureArea: commonHeaders.ApplicationFeatureArea,
                applicationName: commonHeaders.ApplicationName,
                applicationVersion: commonHeaders.ApplicationVersion,
                bodyId: this.mParams.bodyId,
                contentType: commonHeaders['Content-Type'],
                productName: commonHeaders.ProductName,
                deviceType: commonHeaders.DeviceType,
                lastViewedPosition: lastViewedPositionRequest,
                whiny: this.mParams.whiny || 'false',
            };

            const configuration = new Configuration(configurationParameters);
            const lvpApi = new SoCuLastViewedPositionApi(configuration);
            await lvpApi.setSoCuLastViewedPosition(requestParameters);
        } catch (error) {
            Log.e(this.TAG, 'setSocuLastViewedPositionAtService', error);
            throw error;
        }
    }

    async setSocuLastViewedPosition(socuLVPParams: TSocuLastViewedPositionParams): Promise<void> {
        try {
            return await this.setSocuLastViewedPositionAtService(socuLVPParams);
        } catch (error) {
            Log.e(this.TAG, 'error', error);
            throw error;
        }
    }
}
